var _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2886_20778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 18C7.5 18 13.5 13.2 13.5 8C13.5 4.6864 10.8136 2 7.5 2C4.1864 2 1.5 4.6864 1.5 8C1.5 13.2 7.5 18 7.5 18Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.26667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.49961 10.4C7.81478 10.4 8.12687 10.338 8.41805 10.2173C8.70923 10.0967 8.97381 9.91995 9.19667 9.69709C9.41953 9.47423 9.59631 9.20966 9.71692 8.91848C9.83753 8.6273 9.89961 8.31521 9.89961 8.00004C9.89961 7.68486 9.83753 7.37278 9.71692 7.0816C9.59631 6.79042 9.41953 6.52584 9.19667 6.30298C8.97381 6.08012 8.70923 5.90334 8.41805 5.78273C8.12687 5.66211 7.81478 5.60004 7.49961 5.60004C6.86309 5.60004 6.25264 5.85289 5.80255 6.30298C5.35247 6.75307 5.09961 7.36352 5.09961 8.00004C5.09961 8.63656 5.35247 9.24701 5.80255 9.69709C6.25264 10.1472 6.86309 10.4 7.49961 10.4Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.26667,
    strokeLinejoin: "round"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2886_20778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M-2.09961 0.399902H17.1004V19.5999H-2.09961V0.399902Z",
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.d977b52f.svg";
export { ForwardRef as ReactComponent };